import React, { useEffect, useState } from 'react'
import { FaArrowRightLong } from 'react-icons/fa6'
import { NavLink } from 'react-router-dom'
import { fetchNewsArticles } from '../../api/newsArticleApi'
import NewsArticleCards from '../UI/NewsArticleCards'

const NewsArticles = () => {
  const [articles, setArticles] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')

  useEffect(() => {
    let cancelled = false

    async function loadArticles() {
      setLoading(true)
      setError('')
      try {
        const data = await fetchNewsArticles()
        if (!cancelled) {
          setArticles(data.filter((article) => Number(article.status) === 1))
        }
      } catch (err) {
        if (!cancelled) {
          setError(err.message || 'Failed to load news articles')
        }
      } finally {
        if (!cancelled) {
          setLoading(false)
        }
      }
    }

    loadArticles()
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <section className="space-top">
      <div className="container">
        <div className="row">
          <div className="col-lg-9 col-12 mb-3 mb-lg-0">
            <h2 className="fw-semibold ">Myth Busters – News & Articles</h2>
            <p className="light-color">
              Read insightful articles that separate myths from reality in the world of astrology and numerology.
            </p>
          </div>
          <div className="col-lg-3 col-12 d-flex justify-content-lg-end">
            <button className="btn mb-3 mb-lg-0 flex items-center">
              <NavLink
                to="/news-articles"
                className="no-underline text-gray-900 hover:text-[#cda301] hover:underline"
              >
                View All <FaArrowRightLong className="ms-2 d-inline" />
              </NavLink>
            </button>
          </div>
        </div>

        {loading && <p className="text-center py-4">Loading articles...</p>}
        {error && !loading && (
          <p className="text-center py-4 text-danger">{error}</p>
        )}
        {!loading && !error && articles.length === 0 && (
          <p className="text-center py-4">No articles available right now.</p>
        )}
        {!loading && !error && articles.length > 0 && (
          <div className="row shop-product-grid g-3">
            {articles.map((article) => (
              <div
                className="col-xl-3 col-lg-3 col-md-6 col-12"
                key={article.article_id}
              >
                <NewsArticleCards article={article} />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  )
}

export default NewsArticles
